export default __webpack_public_path__ + "static/media/IMG-20241005-WA0023.89e61af8.jpg";